.af{flex-shrink:0;}